import React from 'react';
import { Card, CardContent, CardMedia, Typography, Box, useTheme } from '@mui/material';
import { tokens } from "../../theme";

const Project = ({ project, onClick }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const mediaHeight = { xs: 250, sm: 220, md: 200 };

    return (
        <Card
            onClick={onClick}
            sx={{
                height: '100%',
                cursor: 'pointer',
                backgroundColor: colors.background[300],
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                    transform: 'translateY(-8px)'
                }
            }}
        >
            {project.imgSrc ? (
                <CardMedia
                    component="img"
                    image={project.imgSrc}
                    alt={project.imgAlt}
                    loading="lazy"
                    sx={{
                        height: mediaHeight,
                        width: '100%',
                        objectFit: 'cover'
                    }}
                />
            ) : (
                // Fallback panel for projects with no photography available yet
                <Box
                    sx={{
                        height: mediaHeight,
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 1,
                        px: 3,
                        textAlign: 'center',
                        backgroundColor: colors.background[500],
                        backgroundImage: `linear-gradient(135deg, ${colors.background[500]} 0%, ${colors.background[400]} 100%)`
                    }}
                >
                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontWeight: 700,
                            letterSpacing: '0.08em',
                            textTransform: 'uppercase',
                            fontSize: '0.75rem'
                        }}
                    >
                        {project.sector}
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{
                            color: theme.palette.text.primary,
                            fontWeight: 'bold',
                            fontSize: { xs: '1.25rem', md: '1.4rem' }
                        }}
                    >
                        {project.title}
                    </Typography>
                </Box>
            )}
            <CardContent sx={{ p: { xs: 3, md: 4 } }}>
                <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                        color: theme.palette.text.primary,
                        fontWeight: 'bold',
                        fontSize: { xs: '1.25rem', md: '1.5rem' }
                    }}
                >
                    {project.title}
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.palette.text.secondary,
                            fontSize: { xs: '0.9rem', md: '1rem' }
                        }}
                    >
                        {project.location}
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.palette.text.secondary,
                            fontSize: { xs: '0.9rem', md: '1rem' }
                        }}
                    >
                        •
                    </Typography>
                    <Typography
                        variant="body2"
                        sx={{
                            color: theme.palette.text.secondary,
                            fontSize: { xs: '0.9rem', md: '1rem' }
                        }}
                    >
                        {project.sector}
                    </Typography>
                </Box>
                <Typography
                    variant="body1"
                    sx={{
                        color: theme.palette.text.secondary,
                        fontSize: { xs: '0.95rem', md: '1rem' },
                        lineHeight: 1.6
                    }}
                >
                    {project.description}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default Project;
